import api from './../libs/api';

export default {

    get: (data) => {
        return new Promise((resolve, reject) => {
          api()
            .get(`/job-type`, { params: data })
            .then(({ status, data }) => {
              if (status === 200) resolve(data);
              throw new Error(`Failed with status: ${status}`);
            })
            .catch(error => reject(error));
        });
      },
      

  post: (data) => {
    return new Promise((resolve, reject) => {
      api()
        .post(`/job-type`, data)
        .then(({ status, data }) => {
          if (status === 201) resolve(data);
          throw new Error(`Failed with status: ${status}`);
        })
        .catch(error => reject(error));
    });
  },

  put: (id, data) => {
    return new Promise((resolve, reject) => {
      api()
        .put(`/job-type/${id}`, data)
        .then(({ status, data }) => {
          if (status === 200) resolve(data);
          throw new Error(`Failed with status: ${status}`);
        })
        .catch(error => reject(error));
    });
  },

  delete: (id) => {
    return new Promise((resolve, reject) => {
      api()
        .delete(`/job-type/${id}`)
        .then(({ status, data }) => {
          if (status === 204) resolve(data);
          throw new Error(`Failed with status: ${status}`);
        })
        .catch(error => reject(error));
    });
  },

  

  
}; 